import { createContext, useContext, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
const ModalContext = createContext();
export const ModalContextProvider = ({ children }) => {

  const [isloadingconnect, setIsloadingconnect] = useState(false)
  const [isloading, setIsloading] = useState(false)


  const contextValue = useMemo(() => ({
    isloadingconnect, setIsloadingconnect,
    isloading, setIsloading,
    
  }), [isloadingconnect, isloading]);
  return (
    <ModalContext.Provider value={contextValue}>
      {children}
    </ModalContext.Provider>
  );
};
ModalContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
export const useModalContext = () => useContext(ModalContext); 